<div *ngIf="modo==='normal'">
  <div class="flex flex-col sm:flex-row justify-around gap-5 select-none">
    <div *ngFor="let ico of icons" class="flex flex-col items-center cursor-pointer" (click)="goToTuto(ico.label)">
      <div class="shadow-md rounded-full mb-5 bg-surface h-40 w-40 flex items-center justify-center">
        <i class="mdi {{ico.src}} text-primary text-[60px]"></i>
      </div>
      <div class="text-center text-2xl sm:text-xl text-text-main max-w-[24vw] sm:max-w-full">
        {{ico.label}}
      </div>
    </div>
  </div>
</div>
<modal-open-point id="modal-retiro-sucursal">
  <div normal class="bubletext">
    <modal-retiro-sucursal></modal-retiro-sucursal>
  </div>
</modal-open-point>

<modal-open-point id="modal-compra-online">
  <div normal class="bubletext">
    <modal-compra-online></modal-compra-online>
  </div>
</modal-open-point>

<modal-open-point id="modal-medio-pago">
  <div normal class="bubletext">
    <modal-medio-pago></modal-medio-pago>
  </div>
</modal-open-point>